import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AgreementService } from 'src/app/services/agreement.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-agreement-view',
  templateUrl: './agreement-view.component.html',
  styleUrls: ['./agreement-view.component.scss']
})
export class AgreementViewComponent {
  isProduction: boolean;
  constructor(private route: ActivatedRoute, private agreementService: AgreementService) { 
    this.isProduction = environment.production;
  }
  @Input() agreement: any;
  @Input() preview: boolean = false;
  async ngOnInit() {
    if (this.route.snapshot.params.id)
      this.agreement = await this.agreementService.get(this.route.snapshot.params.id);
  }

  async testSign() {
    if(this.isProduction) return;
    await this.agreementService.testSign(this.agreement.Id);
    this.agreement = await this.agreementService.get(this.agreement.Id);
  }
}
